import React, { useState } from 'react';
import { Link as Anchor, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUtensils, faClipboardList, faGlobe, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import Logout from '../../Admin/Logout/Logout';
import { usePlan } from '../../PlanContext';
import { useLogo } from '../../LogoContext';
import { useCaja } from '../CajaContext';
import { ruta } from '../../paths';
import './NavbarWorker.css';

export default function NavbarWorker() {
    const location = useLocation();
    const [navAbierto, setNavAbierto] = useState(false);
    const { isPlus, esTienda } = usePlan();
    const { logo } = useLogo();
    const { caja } = useCaja();

    return (
        <div className={`navbarDashboard ${navAbierto ? 'navAbierto' : ''}`}>
            <div className='navbarToggleRow'>
                <Anchor className='logo'>
                    <img src={logo} alt="logo" />
                </Anchor>
                <button className='navToggleBtn' onClick={() => setNavAbierto(!navAbierto)}>
                    <FontAwesomeIcon icon={navAbierto ? faTimes : faBars} />
                </button>
            </div>
            <div className='links'>
                <Anchor to={ruta('/trabajador')} className={location.pathname === ruta('/trabajador') ? 'activeLink' : ''} onClick={() => setNavAbierto(false)}>
                    <FontAwesomeIcon icon={faUtensils} /> {esTienda ? 'Vender' : 'Tomar Pedido'}
                </Anchor>
                <Anchor to={ruta('/trabajador/pedidos')} className={location.pathname === ruta('/trabajador/pedidos') ? 'activeLink' : ''} onClick={() => setNavAbierto(false)}>
                    <FontAwesomeIcon icon={faClipboardList} /> {esTienda ? 'Pedidos' : (isPlus ? 'Pedidos Mesas' : 'Mis Pedidos')}
                </Anchor>
                {isPlus && (
                    <Anchor to={ruta('/trabajador/pedidos-web')} className={location.pathname === ruta('/trabajador/pedidos-web') ? 'activeLink' : ''} onClick={() => setNavAbierto(false)}>
                        <FontAwesomeIcon icon={faGlobe} /> Pedidos Web
                    </Anchor>
                )}
            </div>
            <Logout rol="trabajador" cajaAbierta={Boolean(caja)} />
        </div>
    );
}
